import React from "react";
import styled from "styled-components";
import { useNavigate } from "react-router";
import { useSelector } from "react-redux";
import Section from "components/ui/Section";
import ServiceBreakdownList from "components/salesPayment/ServiceBreakdownList";
import { useHomePaymentQuery } from "pages/Sales/_hooks/useHomePaymentQuery";

export const VoucherInfo = () => {
  const navigate = useNavigate();
  const { query } = useHomePaymentQuery();
  const { branchUseYn, seqPartnerBranch } = useSelector((s: any) => s.partner);
  const { data, isLoading, isError, refetch } = query;

  const goDetail = () => {
    const isBranch = branchUseYn === "Y" && seqPartnerBranch === 0;
    navigate(isBranch ? "/sales/branch/voucher" : "/sales/voucher");
  };

  return (
    <Section
      title="이용권 종류별 매출"
      onClick={goDetail}
      onRefresh={() => refetch()}
      isLoading={isLoading}
      isError={isError}
    >
      <Wrapper>
        {data ? (
          <ServiceBreakdownList breakdown={data.serviceBreakdown} />
        ) : null}
      </Wrapper>
    </Section>
  );
};

const Wrapper = styled.div`
  ul {
    margin-top: 4px;
  }
`;

export default VoucherInfo;
